export enum TipoVigencia {
  Vigente = 0,
  Vencido = 1,
  Futuro = 2,
  Todos= 3
}
